<template>
  <modal :show="show" @close="close">
    <div id="ventilator-error-modal" slot="header" class="modal-header">
      <h5 class="modal-title">Entered a Vent Barcode</h5>
      <button id="btn-vent-error-close" type="button" class="close" @click="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">
      The entered barcode belongs to a ventilator and not a patient. Would you like to Start a New Association for
      {{ serialName }}?
    </div>

    <template v-slot:footer>
      <button id="btn-cancel" class="btn btn-light" @click="close">
        Cancel
      </button>
      <button id="btn-keep-change-confirm" class="btn btn-primary" @click="handleNewAssociation">
        Start a New Association
      </button>
    </template>
  </modal>
</template>

<script>
import Modal from "../Modal";

export default {
  name: "VentilatorModal",
  props: ["show", "scannedEntity"],
  mounted() {
    console.log(this.show);
    console.log(this.scannedEntity);
  },
  computed: {
    serialName() {
      return this.scannedEntity.name ? this.scannedEntity.name : this.scannedEntity.serial;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleNewAssociation() {
      this.$emit("startNewAssociation");
      this.$emit("close");
    }
  },
  components: {
    modal: Modal
  }
};
</script>

<style scoped></style>
